import { render, staticRenderFns } from "./DomainCrawlSummary.vue?vue&type=template&id=584f83ed&scoped=true&"
import script from "./DomainCrawlSummary.vue?vue&type=script&lang=js&"
export * from "./DomainCrawlSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "584f83ed",
  null
  
)

export default component.exports